import type { Api } from './api';

/** Estensione → tipo MIME dei file accettati (immagini e PDF, come l'API `/uploads`). */
export const UPLOAD_TYPES: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  heic: 'image/heic',
  heif: 'image/heif',
  pdf: 'application/pdf',
};
/** formati che il browser sa mostrare subito come anteprima (HEIC e PDF no) */
export const PREVIEWABLE = new Set(['image/jpeg', 'image/png', 'image/webp']);
export const MAX_UPLOAD_MB = 30;

/** Tipo MIME dal file; alcuni browser non lo danno per HEIC: si ricava dall'estensione. */
export function mimeOf(file: File): string | undefined {
  if (Object.values(UPLOAD_TYPES).includes(file.type)) return file.type;
  return UPLOAD_TYPES[file.name.split('.').pop()?.toLowerCase() ?? ''];
}

/** POST multipart su S3 con l'avanzamento (fetch non lo espone per l'upload). */
export function postWithProgress(url: string, body: FormData, onProgress: (pct: number) => void) {
  return new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.upload.onprogress = (e) =>
      e.lengthComputable && onProgress(Math.round((e.loaded / e.total) * 100));
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300
        ? resolve()
        : reject(new Error(`caricamento non riuscito (${xhr.status})`));
    xhr.onerror = () => reject(new Error('caricamento interrotto: controlla la connessione'));
    xhr.send(body);
  });
}

/** Carica il file originale nel bucket raw (`admin-uploads/`) e restituisce la sua chiave. */
export async function uploadOriginal(
  api: Api,
  file: File,
  type: string,
  onProgress: (pct: number) => void = () => {},
): Promise<string> {
  const up = await api<{ url: string; fields: Record<string, string>; key: string }>('/uploads', {
    method: 'POST',
    body: { contentType: type, size: file.size },
  });
  const form = new FormData();
  for (const [k, v] of Object.entries(up.fields)) form.append(k, v);
  form.append('file', file);
  await postWithProgress(up.url, form, onProgress);
  return up.key;
}
